import { BillingInfo, ApiBillingUpdate } from "Types"

export const formatBillingEdit = (model: BillingInfo): ApiBillingUpdate => ({
  name: model.name,
  email: model.email,
  ddd: model.phone.ddd,
  phoneNumber: model.phone.number.replace('-', ''),
  cnpJ_CPF: model.cpfcnpj,
  zipCode: model.location.zipcode.replace('-', ''),
  neighborhood: model.location.neighborhood,
  street: model.location.street,
  streetNumber: model.location.streetNumber,
  complementary: model.location.streetDetails,
  cityId: model.location.city,
})

export default {
  formatBillingEdit
}